import { render, staticRenderFns } from "./articleList.vue?vue&type=template&id=f7d2036c&scoped=true"
import script from "./articleList.vue?vue&type=script&lang=js"
export * from "./articleList.vue?vue&type=script&lang=js"
import style0 from "./articleList.vue?vue&type=style&index=0&id=f7d2036c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d2036c",
  null
  
)

export default component.exports